import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useFormikContext } from "formik";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftFooter,
  CftReportProgress,
  CftActionsButtons,
  CftExportReport,
  CftTank,
} from "../../../components";
import routes from "../../../utils/cftRoutes";
import { useCft } from "../../../utils/CftProvider";
import CarbonChangesBothCalcForm, {
  CarbonChangesBothCalcFormContext,
} from "../../../forms/farmlands/bothCalc/CarbonChangesBothCalcForm/CarbonChangesBothCalc.form";

function CarbonChangesBothCalcPage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { submitForm, values, isSubmitting } = useFormikContext();
  const { saveBothCalc, meta } = useCft();

  return (
    <CftLayout
      header={
        <CftHeader
          progressValue={70}
          cropName={meta.title.bothCalc}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportReport type="bothCalc" />

              <CftActionsButtons.CancelButton
                onClick={() => {
                  saveBothCalc({
                    carbonChanges: values,
                  });
                  history.push(routes.FARMLANDS.BOTH_CALC.MAIN);
                }}
              />
            </CftTank>
          }
        />
      }
      footer={
        <CftFooter
          isPending={isSubmitting}
          text={t("cft:carbonChanges.title", "Zmiany węglowe")}
          onBack={() => history.push(routes.FARMLANDS.BOTH_CALC.IRRIGATION)}
          onNext={submitForm}
        />
      }
    >
      <CftSection
        header={
          <>
            <h3>{t("cft:carbonChanges.title", "Zmiany węglowe")}</h3>
            <p>
              {t(
                "cft:carbonChanges.subtitle",
                "Zaznacz odpowiednie pola poniżej, jeśli w ciągu ostatnich 20 lat dokonałeś zmian w użytkowaniu gruntów, uprawie lub uprawie okrywowej / międzyplonowej na obszarze oceny."
              )}
            </p>
          </>
        }
      >
        <CarbonChangesBothCalcForm />
        <CftReportProgress type="bothCalc" />
      </CftSection>
    </CftLayout>
  );
}

export default () => {
  return (
    <CarbonChangesBothCalcFormContext>
      <CarbonChangesBothCalcPage />
    </CarbonChangesBothCalcFormContext>
  );
};
